// @vendors
import { useTranslation } from "react-i18next";

const UpgradeCard = () => {
    const { t } = useTranslation();

    return (
        <div className="w-full bg-white dark:bg-dark-cBackground p-6 rounded-lg shadow-md flex flex-col overflow-auto">
            <h3 className="text-[18px] font-bold mb-5 dark:text-dark-cText">
                🚀 {t("professional.dashboard.upgrade.title")} 🚀
            </h3>
            <div className="flex lg:flex-row flex-col gap-2 lg:px-4 px-0 w-full">
                <p className="mb-2 text-cTextSecondary dark:text-dark-cText/60 font-medium text-[15px]">
                    {t("professional.dashboard.upgrade.firsText")} <br />
                    <br />
                    {t("professional.dashboard.upgrade.secondText")}
                </p>
                <div className="w-full lg:w-[160px] flex flex-col items-center">
                    <img
                        src="/assets/img/dashboard/person-stats.png"
                        alt="Upgrade illustration"
                        className="w-[100px] h-auto mb-3"
                    />
                    <button
                        className="bg-bgBrand hover:bg-bgBrandHover disabled:bg-gray-200 text-white px-4 py-2 rounded-md w-[150px]"
                        //onClick={}
                        disabled={true}
                    >
                        {t("professional.dashboard.upgrade.buttonShow")}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default UpgradeCard;